// Owner: interaction-kit (wave 1), design-system (wave 2). Whether the interaction-kit developer pages
// (/dev/interaction, /dev/extensions) and the discovery probe (`features/_probe/`) exist in this build.

/**
 * Development builds, and production builds made with `VITE_DR_DEV_PAGES=1` (the `pnpm verify` e2e
 * gate builds the app that way, so the specs of these pages run against a production bundle as well).
 * Deployed builds never set it.
 */
export const devPagesEnabled: boolean =
  import.meta.env.DEV || String(import.meta.env.VITE_DR_DEV_PAGES ?? '') === '1';
